class PaginationLabel extends HTMLElement {

  constructor() {
    super();

    this.state = {
      root: window.theme.tagalys.results.stateLayer.state
    }

    // Store bound handlers for cleanup
    this._boundHandlers = {
      handleProductsUpdated: (products) => {
        if(products.length > 0) {
          this.render()
        } else {
          this.classList.add('hidden');
        }
      },
    }
  }

  connectedCallback() {
    this.subscribeToEvents();
  }

  disconnectedCallback() {
    this.unsubscribeFromEvents();
  }

  subscribeToEvents() {
    window.theme.tagalys.results.eventBus.subscribe('results:state:products:updated', this._boundHandlers.handleProductsUpdated)
  }

  unsubscribeFromEvents() {
    window.theme.tagalys.results.eventBus.unsubscribe('results:state:products:updated', this._boundHandlers.handleProductsUpdated)
  }

  render() {
    const { pagination } = this.state.root;

    if (pagination.page === undefined) {
      console.log('unable to render pagination label');
      this.setAttribute('hidden', '');
      return;
    }


    const start = (pagination.page - 1) * pagination.size + 1;
    const end = Math.min(pagination.page * pagination.size, pagination.total);

    this.innerHTML = '';
    this.insertAdjacentHTML('beforeend', `Showing ${start} - ${end} of ${pagination.total}`);
  }
}

customElements.define('pagination-label', PaginationLabel);
